import { Editor } from 'react-draft-wysiwyg';
import styles from './newsEditor.module.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const StyleThreeContent = ({
    editorState,
    setEditorState,

}) => {

    return (
        <>
            <div className={styles.option1Layout}>
                <div style={{ flex: 1 }} className={styles.textEditor}>
                    <Editor
                        editorState={editorState}
                        onEditorStateChange={setEditorState}
                        wrapperClassName={styles.editorWrapper}
                        editorClassName={styles.editor}
                        toolbar={{
                            options: [
                                'inline',
                                'blockType',
                                'list',
                                'textAlign',
                                'link',
                                'emoji',
                                'history'
                            ],
                            blockType: {
                                options: [
                                    'Normal', // unstyled text
                                    'H2',
                                    'H3',
                                ],
                            },
                            inline: {

                                options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                            },
                            list: {

                                options: ['unordered', 'ordered', 'indent', 'outdent'],
                            },
                            textAlign: {

                                options: ['left', 'center', 'right', 'justify'],
                            },
                            link: {
                                inDropdown: false,
                                // options: ['link', 'unlink'],
                            },
                            history: {
                                options: ['undo', 'redo'],
                            }
                        }}
                    />

                </div>
            </div>
        </>
    );
};

export default StyleThreeContent;
